import { Component, EventEmitter, Output, inject } from '@angular/core';
import { IonRouterOutlet, ModalController } from '@ionic/angular';
import { AuthComponent } from '../../../auth/auth.component';
import { AuthService } from '../../../auth/auth.service';
import { User } from '../../models/user.model';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { IonicModule } from '@ionic/angular';
import { Router, RouterModule } from '@angular/router';

@Component({
    selector: 'app-login-modal',
    templateUrl: './login-modal.component.html',
    styleUrls: ['./login-modal.component.scss'],
    standalone: true,
    imports: [CommonModule, TranslateModule, IonicModule, RouterModule], // 👈 add this
})
export class LoginModalComponent {
    private authService = inject(AuthService);
    private modalController = inject(ModalController);
    private routerOutlet = inject(IonRouterOutlet);
    private router = inject(Router);

    @Output() isAuthenticated: EventEmitter<User> = new EventEmitter();

    async login() {
        localStorage.setItem('redirectAfterLogin', this.router.url);
        const modal = await this.modalController.create({
            component: AuthComponent,
            presentingElement: this.routerOutlet.nativeEl,
            componentProps: {
                isLoginModal: true
            },
            cssClass: 'login-modal'
        });

        await modal.present();

        const { data } = await modal.onDidDismiss();

        if (data?.data === 'login-success') {
            const isSuccess = await this.authService.isAuthenticated();
            if (isSuccess) {
                modal.dismiss();
            }
            this.isAuthenticated.emit(this.authService.authUserSignal());
        }
    }

}
